// extracted by mini-css-extract-plugin
module.exports = {"document":"legal-document_document__g_2Iq"};